module.exports = __webpack_public_path__ + "media/images/familiar-group-of-three-persons-father-mother-and-son-3dca8e574f666e0b35f8730a18812e5a.svg";